// Pages/ShippingAddress.jsx
import React, { useState, useEffect,useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/InvoiceCard.css";
import {
  fetchCustomerByCode,
  fetchAllCountries,
  fetchRegionsByCountry,
  fetchDistrictsByRegion,
  fetchTehsilsByDistrict,
  fetchCitiesByTehsil,
  saveShippingAddress,
  fetchCustomerCode
} from "../Api/InvoiceApi";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ShippingAddress = () => {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  
  const [billingAddress, setBillingAddress] = useState({
    name: "",
    address1: "",
    address2: "",
    address3: "",
    countryCode: "",
    regionName: "",
    districtName: "",
    tehsilName: "",
    cityName: "",
    PinCode:""
  });
  console.log("Billing",billingAddress);
  const[check,setCheck]=useState(false);
  const [shippingAddress, setShippingAddress] = useState({
    name:"",
    address1:"",
    address2: "",
    address3: "",
    countryCode: "",
    regionCode: "",
    districtCode: "",
    tehsilCode: "",
    cityCode: "",
    PinCode:"",
  });
  console.log(billingAddress.regionName);
  const [dropdownData, setDropdownData] = useState({
    countries: [],
    regions: [],
    districts: [],
    tehsils: [],
    cities: []
  });

  const [loading, setLoading] = useState({
    customer: false,
    countries: false,
    regions: false,
    districts: false,
    tehsils: false,
    cities: false,
    saving: false
  });
  
  const [customerCode, setCustomerCode] = useState("");

useEffect(() => {
  console.log('we run this useEffect');

  const initialize = async () => {
    try {
      const savedCustomerCode = await fetchCustomerCode(invoiceId); 
      console.log(savedCustomerCode, 'savedCustomerCode');

      if (savedCustomerCode) {
        setCustomerCode(savedCustomerCode);

        await fetchBillingAddress(savedCustomerCode);
        await fetchCountries();
      } else {
        toast.error("Customer code not found. Please go back and select a customer.");
        setTimeout(() => navigate('/create-invoice'), 2000);
      }
    } catch (error) {
      console.error("Error initializing invoice:", error);
      toast.error("An error occurred while loading invoice data.");
    }
  };

  initialize();
}, [invoiceId, navigate]); 


  const fetchBillingAddress = async (code) => {
    setLoading({ ...loading, customer: true });
    try {
      const customerData = await fetchCustomerByCode(code);
      console.log(customerData);
      setBillingAddress({
        name: customerData.name || "",
        address1: customerData.address1 || "",
        address2: customerData.address2 || "",
        address3: customerData.address3 || "",
        countryCode: customerData.countryCode || "",
        regionName: customerData.regionName || "",
        districtName: customerData.districtName || "",
        tehsilName: customerData.tehsilName || "",
        cityName: customerData.cityName || "",
        PinCode:customerData.pinCode || "",

      });
    } catch (error) {
      console.error("Error fetching billing address:", error);
      toast.error("Failed to load billing address");
    } finally {
      setLoading({ ...loading, customer: false });
    }
  };

  const fetchCountries = async () => {
    setLoading({ ...loading, countries: true });
    try {
      const countries = await fetchAllCountries();
      setDropdownData(prev => ({ ...prev, countries: countries || [] }));
    } catch (error) {
      console.error("Error fetching countries:", error);
      toast.error("Failed to load countries");
    } finally {
      setLoading({ ...loading, countries: false });
    }
  };

const fetchRegions = async (countryCode) => {
  if (!countryCode) return [];
  setLoading(prev => ({ ...prev, regions: true }));
  let regions = [];
  try {
    regions = await fetchRegionsByCountry(countryCode);
    setDropdownData(prev => ({ ...prev, regions: regions || [] }));
    // Reset dependent dropdowns
    setDropdownData(prev => ({ ...prev, districts: [], tehsils: [], cities: [] }));
    if (!copyingShippingRef.current && check) {
      setShippingAddress(prev => ({ ...prev, regionCode: "", districtCode: "", tehsilCode: "", cityCode: "" }));
    }
    return regions || [];
  } catch (error) {
    console.error("Error fetching regions:", error);
    toast.error("Failed to load regions");
    return [];
  } finally {
    setLoading(prev => ({ ...prev, regions: false }));
  }
};


const fetchDistricts = async (regionCode) => {
  if (!regionCode) return [];
  setLoading(prev => ({ ...prev, districts: true }));
  let districts = [];
  try {
    districts = await fetchDistrictsByRegion(regionCode);
    setDropdownData(prev => ({ ...prev, districts: districts || [] }));
    // Reset dependent dropdowns
    setDropdownData(prev => ({ ...prev, tehsils: [], cities: [] }));
    if (!copyingShippingRef.current && check) {
      setShippingAddress(prev => ({ ...prev, districtCode: "", tehsilCode: "", cityCode: "" }));
    }
    return districts || [];
  } catch (error) {
    console.error("Error fetching districts:", error);
    toast.error("Failed to load districts");
    return [];
  } finally {
    setLoading(prev => ({ ...prev, districts: false }));
  }
};

const fetchTehsils = async (districtCode) => {
  if (!districtCode) return [];
  setLoading(prev => ({ ...prev, tehsils: true }));
  let tehsils = [];
  try {
    tehsils = await fetchTehsilsByDistrict(districtCode);
    setDropdownData(prev => ({ ...prev, tehsils: tehsils || [] }));
    // Reset dependent dropdowns
    setDropdownData(prev => ({ ...prev, cities: [] }));
    if (!copyingShippingRef.current && check) {
      setShippingAddress(prev => ({ ...prev, tehsilCode: "", cityCode: "" }));
    }
    return tehsils || [];
  } catch (error) {
    console.error("Error fetching tehsils:", error);
    toast.error("Failed to load tehsils");
    return [];
  } finally {
    setLoading(prev => ({ ...prev, tehsils: false }));
  }
};


 const fetchCities = async (tehsilCode) => {
  if (!tehsilCode) return [];
  setLoading(prev => ({ ...prev, cities: true }));
  let cities = [];
  try {
    cities = await fetchCitiesByTehsil(tehsilCode);
    setDropdownData(prev => ({ ...prev, cities: cities || [] }));
    if (!copyingShippingRef.current && check) {
      setShippingAddress(prev => ({ ...prev, cityCode: "" }));
    }
    return cities || [];
  } catch (error) {
    console.error("Error fetching cities:", error);
    toast.error("Failed to load cities");
    return [];
  } finally {
    setLoading(prev => ({ ...prev, cities: false }));
  }
};


  const handleShippingChange = (e) => {
    const { name, value } = e.target;
    setShippingAddress({ ...shippingAddress, [name]: value });

    // Fetch dependent data when country/region/district/tehsil changes
    if (name === 'countryCode') {
      fetchRegions(value);
    } else if (name === 'regionCode') {
      fetchDistricts(value);
    } else if (name === 'districtCode') {
      fetchTehsils(value);
    } else if (name === 'tehsilCode') {
      fetchCities(value);
    }
  };
const copyingShippingRef = useRef(false);
  const copyBillingToShipping = async () => {
  copyingShippingRef.current = true;
  setCheck(true);


  setShippingAddress(prev => ({
    ...prev,
    name: billingAddress.name || "",
    address1: billingAddress.address1 || "",
    address2: billingAddress.address2 || "",
    address3: billingAddress.address3 || "",
    countryCode: billingAddress.countryCode || "",
    regionCode: "",
    districtCode: "",
    tehsilCode: "",
    cityCode: "",
    PinCode:billingAddress.PinCode||""
  }));

  try {

    const regions = billingAddress.countryCode ? await fetchRegions(billingAddress.countryCode) : [];
    let matchedRegion = null;
    if (regions && regions.length) {
      matchedRegion = regions.find(r =>
        (r.regionName && r.regionName.toString() === (billingAddress.regionName || "").toString()) ||
        (r.regionCode && r.regionCode.toString() === (billingAddress.regionName || "").toString())
      );
    }
    if (matchedRegion) {
      setShippingAddress(prev => ({ ...prev, regionCode: matchedRegion.regionCode }));
    } else {
      console.warn("Region code not found for", billingAddress.regionName);
    }

    if (matchedRegion && matchedRegion.regionCode) {
      const districts = await fetchDistricts(matchedRegion.regionCode);
      const matchedDistrict = districts.find(d =>
        (d.description && d.description.toString() === (billingAddress.districtName || "").toString()) ||
        (d.code && d.code.toString() === (billingAddress.districtName || "").toString())
      );
      if (matchedDistrict) {
        setShippingAddress(prev => ({ ...prev, districtCode: matchedDistrict.code }));
      } else {
        console.warn("District code not found for", billingAddress.districtName);
      }

      const districtCodeToUse = matchedDistrict ? matchedDistrict.code : "";
      if (districtCodeToUse) {
        const tehsils = await fetchTehsils(districtCodeToUse);
        const matchedTehsil = tehsils.find(t =>
          (t.description && t.description.toString() === (billingAddress.tehsilName || "").toString()) ||
          (t.code && t.code.toString() === (billingAddress.tehsilName || "").toString())
        );
        if (matchedTehsil) {
          setShippingAddress(prev => ({ ...prev, tehsilCode: matchedTehsil.code }));
        } else {
          console.warn("Tehsil code not found for", billingAddress.tehsilName);
        }

        const tehsilCodeToUse = matchedTehsil ? matchedTehsil.code : "";
        if (tehsilCodeToUse) {
          const cities = await fetchCities(tehsilCodeToUse);
          const matchedCity = cities.find(c =>
            (c.description && c.description.toString() === (billingAddress.cityName || "").toString()) ||
            (c.code && c.code.toString() === (billingAddress.cityName || "").toString())
          );
          if (matchedCity) {
            setShippingAddress(prev => ({ ...prev, cityCode: matchedCity.code }));
          } else {
            console.warn("City code not found for", billingAddress.cityName);
          }
        }
      }
    }
    toast.success("Billing address copied to shipping address!");
  } catch (err) {
    console.error("Error syncing dropdowns after copy:", err);
    toast.error("Failed to copy full address");
  } finally {
    copyingShippingRef.current = false;
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading({ ...loading, saving: true });

    try {
      const shippingData = {
        invoiceId,
        name: shippingAddress.name,
        address1: shippingAddress.address1,
        address2: shippingAddress.address2,
        address3: shippingAddress.address3,
        countryCode: shippingAddress.countryCode,
        regionCode: shippingAddress.regionCode,
        districtCode: shippingAddress.districtCode,
        tehsilCode: shippingAddress.tehsilCode,
        cityCode: shippingAddress.cityCode,
        pinCode:shippingAddress.PinCode
      };
      console.log(shippingData);
      const response = await saveShippingAddress(shippingData, "27"); 
      
      toast.success("Shipping address saved successfully!", {
        onClose: () => navigate(`/create-invoice/${invoiceId}`)
      });

    } catch (error) {
      console.error("Error saving shipping address:", error);
      toast.error(error.message || "Failed to save shipping address");
    } finally {
      setLoading({ ...loading, saving: false });
    }
  };

  return (
    <div className="container-fluid py-4">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="card shadow-sm border-0 rounded-4 p-4 mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h4 className="fw-bold text-dark mb-1">
              Shipping Address - Invoice #{invoiceId}
            </h4>
            <p className="text-muted mb-2">
              Enter billing and shipping address details
            </p>
          </div>
        </div>
      </div>

      <div className="row">
        {/* Billing Address Section */}
        <div className="col-md-6">
          <div className="card shadow-sm border-0 rounded-4 p-4 h-100">
            <div className="d-flex align-items-center mb-4">
              <div className="icon-box me-2">
                🏢
              </div>
              <h5 className="fw-bold mb-0 text-dark">Billing Address</h5>
            </div>

            {loading.customer ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading billing address...</p>
              </div>
            ) : (
              <div className="row g-3">
                {['name', 'address1', 'address2', 'address3','PinCode', 'countryCode', 'regionName', 'districtName', 'tehsilName', 'cityName'].map((field) => (
                  <div key={field} className="col-12">
                    <label className="form-label fw-semibold text-capitalize">
                      {field.replace(/([A-Z])/g, ' $1').trim()}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={billingAddress[field] || ''}
                      readOnly
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Shipping Address Section */}
        <div className="col-md-6">
          <div className="card shadow-sm border-0 rounded-4 p-4 h-100">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex align-items-center">
                <div className="icon-box me-2">
                  🚚
                </div>
                <h5 className="fw-bold mb-0 text-dark">Shipping Address</h5>
              </div>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={copyBillingToShipping}
              >
                📋 Copy Billing Address
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label fw-semibold">Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={shippingAddress.name}
                    onChange={handleShippingChange}
                    required
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Address 1 *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address1"
                    value={shippingAddress.address1}
                    onChange={handleShippingChange}
                    required
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Address 2</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address2"
                    value={shippingAddress.address2}
                    onChange={handleShippingChange}
                  />
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Address 3</label>
                  <input
                    type="text"
                    className="form-control"
                    name="address3"
                    value={shippingAddress.address3}
                    onChange={handleShippingChange}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label fw-semibold">Pin Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="PinCode"
                    value={shippingAddress.PinCode}
                    onChange={handleShippingChange}
                  />
                </div>

                

                <div className="col-12">
                  <label className="form-label fw-semibold">Country *</label>
                  <select
                    className="form-select"
                    name="countryCode"
                    value={shippingAddress.countryCode}
                    onChange={handleShippingChange}
                    required
                    disabled={loading.countries}
                  >
                    <option value="">Select Country</option>
                    {dropdownData.countries.map((country) => (
                      <option key={country.countryCode} value={country.countryCode}>
                        {country.countryCode} - {country.countryName}
                      </option>
                    ))}
                  </select>
                  {loading.countries && <small className="text-muted">Loading countries...</small>}
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Region *</label>
                  <select
                    className="form-select"
                    name="regionCode"
                    value={shippingAddress.regionCode}
                    onChange={handleShippingChange}
                    required
                    disabled={loading.regions || !shippingAddress.countryCode}
                  >
                    <option value="">Select Region</option>
                    {dropdownData.regions.map((region) => (
                      <option key={region.regionCode} value={region.regionCode}>
                        {region.regionCode} - {region.regionName}
                      </option>
                    ))}
                  </select>
                  {loading.regions && <small className="text-muted">Loading regions...</small>}
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">District *</label>
                  <select
                    className="form-select"
                    name="districtCode"
                    value={shippingAddress.districtCode}
                    onChange={handleShippingChange}
                    required
                    disabled={loading.districts || !shippingAddress.regionCode}
                  >
                    <option value="">Select District</option>
                    {dropdownData.districts.map((district) => (
                      <option key={district.code} value={district.code}>
                        {district.code} - {district.description}
                      </option>
                    ))}
                  </select>
                  {loading.districts && <small className="text-muted">Loading districts...</small>}
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">Tehsil *</label>
                  <select
                    className="form-select"
                    name="tehsilCode"
                    value={shippingAddress.tehsilCode}
                    onChange={handleShippingChange}
                    required
                    disabled={loading.tehsils || !shippingAddress.districtCode}
                  >
                    <option value="">Select Tehsil</option>
                    {dropdownData.tehsils.map((tehsil) => (
                      <option key={tehsil.code} value={tehsil.code}>
                        {tehsil.code} - {tehsil.description}
                      </option>
                    ))}
                  </select>
                  {loading.tehsils && <small className="text-muted">Loading tehsils...</small>}
                </div>

                <div className="col-12">
                  <label className="form-label fw-semibold">City *</label>
                  <select
                    className="form-select"
                    name="cityCode"
                    value={shippingAddress.cityCode}
                    onChange={handleShippingChange}
                    required
                    disabled={loading.cities || !shippingAddress.tehsilCode}
                  >
                    <option value="">Select City</option>
                    {dropdownData.cities.map((city) => (
                      <option key={city.code} value={city.code}>
                        {city.code} - {city.description}
                      </option>
                    ))}
                  </select>
                  {loading.cities && <small className="text-muted">Loading cities...</small>}
                </div>

                <div className="d-flex justify-content-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={loading.saving}
                  >
                    {loading.saving ? 'Saving...' : 'Add Item Details'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingAddress;